export const getIsPaired = (state: StationStore) => state.role === "camera";

const selectors = {
  getIsPaired,
};

export default selectors;
